import React from 'react';
import {Link} from 'react-router-dom';
import { login, isLoggedIn } from '../utils/AuthService';
import './Navbar.css';

const Nav = (props) => {
  return (
    <div className='nav'>
      {
        ( isLoggedIn() ) ? <Link to="/playlists"><div className="navbar-brand">Playlist Filter</div></Link> : <Link to="/"><div className="navbar-brand">Playlist Filter</div></Link>
      } 
      <nav>
        <Link to="/contact">Contact</Link>
        {
          ( isLoggedIn() ) ? <Link to="/user/profile">Profile</Link> : <a href="" onClick={login}>Login</a>
        }
      </nav>
    </div>
  );
};

export default Nav;


// WEBPACK FOOTER //
// ./src/components/Navbar.js